export const getGenderTranslateValue = (value) => (value === '0' ? 'مرد' : 'زن');

export const getMaritalTranslateValue = (value) => (value === '0' ? 'مجرد' : 'متاهل');

export const getMilitaryStatusTranslateValue = (value) => {
  switch (value) {
    case '0':
      return 'انجام شده';
    case '1':
      return 'معاف دائم';
    case '2':
      return 'معافیت تحصیلی';
    case '3':
      return 'در حال انجام';
    case '4':
      return 'مشمول';
    default:
      return '';
  }
};

export const getJobGroupTranslateValue = (value) => {
  switch (value) {
    case 'G1':
      return 'مشاغل تجاری و فروش';
    case 'G2':
      return 'خدماتی';
    case 'G3':
      return 'امور حقوقی و اداری';
    case 'G4':
      return 'آموزشی و تربیتی';
    case 'G5':
      return 'سلامت و روان';
    case 'G6':
      return 'صنعتی و فنی';
    case 'G7':
      return 'تولیدی و صنایع دستی';
    case 'G8':
      return 'فناوری اطلاعات و کسب و کار اینترنتی';
    case 'G9':
      return 'بازارهای مالی و امور بانکی';
    case 'G10':
      return 'مدیریت و فرماندهی';
    case 'G11':
      return 'فرهنگ و هنر';
    case 'G12':
      return 'کارآفرینی';

    default:
      return '';
  }
};
